export const VISITORS_INSIDE_METRIC: string = 'fpc_sum_pass_count_in_wh - fpc_sum_pass_count_out_wh';
